// extracted by mini-css-extract-plugin
export default {"loading":"UploadingComponent_loading__k1PwP"};